
import InnerPageTitle from '@/components/Shared/InnerPageTitle/index.vue'
import CategoryCard from './CategoryCard.vue'
import Category2 from '../Home/Category-2.vue'
import NoFound from '../Shared/NoFound/index.vue'
import EmptySearch from '../Search/EmptySearch.vue'
import { mapGetters } from 'vuex'
export default {
  components: { InnerPageTitle, CategoryCard, NoFound, EmptySearch, Category2 },
  computed: {
    ...mapGetters({
      getCategories: 'categories/getCategories',
    }),
  },
}
